import logo from './logo.svg'
import exit from './exit.svg'
import vector from './vector.svg'
import home from './home.svg'
import homeWhite from './homeWhite.svg'
import statistic from './statistic.svg'
import statisticWhite from './statisticWhite.svg'
import orangeVector from './orangeVector.svg'
import whiteVector from './whiteVector.svg'
import plus from './plus.svg'
import minus from './minus.svg'
import calendar from './calendar.svg'
import pencil from './pencil.svg'

export default {logo,exit,vector,home,statistic,homeWhite,statisticWhite,orangeVector,whiteVector,plus,minus,calendar,pencil}
